/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, DateRange, Highcharts, mp, RelativeDate */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var compare_version = function(v1, v2) {
    var v1_split = _.map(v1.split(`.`), Number);
    var v2_split = _.map(v2.split(`.`), Number);
    if (v1_split > v2_split) {
      return -1;
    } else if (v1_split < v2_split) {
      return 1;
    }
    return 0;
  };

  ns.IOSFragmentation = mp.marketing.trends.widgets.TrendReport.extend({
    get_defaults() {
      return {
        date_range: new DateRange(new RelativeDate(-30), new Date()),
      };
    },

    get_queries() {
      var date_range = this.session.get(`date_range`);
      return {
        base: {
          'query_name': `ios_fragmentation`,
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'to_date': date_range.to().toString(mp.utility.default_date_format),
        },
      };
    },

    get_chart_params(query_data) {
      delete query_data.base.Unknown;

      var data = _.extend({}, query_data.base);

      var total_count = _.reduce(data, function(memo, dates, segment) {
        var n = _.reduce(dates, function(m, v) { return m + v; }, 0);
        data[segment] = n;
        return memo + n;
      }, 0);

      var top_segments = this._top_n_segments(data, 20);
      top_segments.sort(compare_version);

      var chart_data = _.map(top_segments, function(segment, i) {
        var percent = (data[segment] / total_count) * 100;
        return {
          'name': segment,
          'y': percent ? percent : 0,
          'color': mp.charts.nth_color(i),
        };
      });

      return {
        'xAxis': {'categories': top_segments, 'type': `linear`},
        'yAxis': {'labels': {'formatter'() { return this.value + `%`; }}},
        'series': [{'data': chart_data, 'type': `column`}],
        'tooltip': {
          'backgroundColor': `rgba(255, 255, 255, 1)`,
          'borderWidth': 1,
          'useHTML': false,
          'formatter'() {
            var n = Highcharts.numberFormat(this.y, 2) + `%`;
            return `<b>`+ mp.utility.sanitize(this.point.name || this.series.name) +`</b>: `+
                            `<div style="text-align: right">` + n + `</div>`;
          },
        },
      };
    },

    getDownloadName() {
      return ns.IOSFragmentation.nice_name;
    },
  });

  // used by the data_viewer to render pretty dropdowns and stuff
  ns.IOSFragmentation.slug = `ios_frag`;
  ns.IOSFragmentation.nice_name = `iOS versions`;
  ns.IOSFragmentation.description = `Are consumers still quick to update the OS on their Apple devices?`;
  ns.IOSFragmentation.chart_type = `bar`;
});

}.call(window));